import { api } from './api';

interface CheckoutQuoteInput {
  readonly type: 'quote';
  readonly quoteId: string;
  readonly materialId: string;
  readonly color: string;
  readonly quantity: number;
  readonly couponCode?: string | null;
}

interface CheckoutProductInput {
  readonly type: 'product';
  readonly productId: string;
  readonly materialId: string;
  readonly color: string;
  readonly quantity: number;
  readonly couponCode?: string | null;
}

type CheckoutInput = CheckoutQuoteInput | CheckoutProductInput;

interface CheckoutResponse {
  readonly sessionUrl: string;
}

export const paymentsApi = {
  createCheckout: async (input: CheckoutInput): Promise<CheckoutResponse> => {
    const response = await api.post<CheckoutResponse>('/payments/checkout', input);
    if (!response.data?.sessionUrl) {
      throw new Error('Failed to create checkout session');
    }
    return response.data;
  },
};
